import React from 'react'
import {IProject} from "../../models/interfaces/project.interface.ts";
import iso6391 from "iso-639-1";
import ProjectStateBadge from "../ProjectStateBadge.tsx";
import {mapStateDtoToEnum} from "../../models/enums/state.enum.ts";
import SmartIcon from "../SmartIcon.tsx";
import ProgressBar from "../ProgressBar.tsx";
import {IoReload} from "react-icons/io5";
import {useProjectsStore} from "../../store/useProjectsStore.ts";
import {downloadFeatures} from "../../services/projectService.ts";


interface TranscriptionFeatureProgressProps {
  project: IProject;
}

const TranscriptionFeatureProgress: React.FC<TranscriptionFeatureProgressProps> = (
  {
    project
  }: TranscriptionFeatureProgressProps) => {
  const {resetFeature} = useProjectsStore();

  const downloadLanguageFeature = async () => {
    const info: {
      subtitles?: string[],
      audioDescriptions?: string[],
      dialogueList?: boolean,
      extendedMetadata?: boolean,
    } = {}
    info["subtitles"] = [project.sourceLanguage]
    downloadFeatures(project.id,project.name, info).catch(console.error);
  }

  const resetLanguageFeature = async () => {
    await resetFeature(project.id, "subtitleTranslations", project.sourceLanguage);
  }


  return (
    <tr key="transcription" className="border-b border-n-600 last:border-b-0">
      <td className="text-left px-4 py-2">{iso6391.getName(project.sourceLanguage)}</td>
      <td className="text-left px-4 py-2">
        <ProgressBar percentage={project.transcription.status == "co" ? 100 : null}/>
      </td>
      <td className="text-left px-4 py-2">
        <ProjectStateBadge
          state={mapStateDtoToEnum(project.transcription.status)}
          enableTooltip={false}
        />
      </td>
      <td className="text-center px-4 py-2">
        {
          project.transcription.status == "fa" && (
            <div onClick={resetLanguageFeature}>
              <SmartIcon
                name={IoReload}
                fill="#fff"
                className="w-5 h-5 cursor-pointer"
              />
            </div>
          )
        }
        {project.transcription.status == "co" && (
          <div onClick={downloadLanguageFeature}>
            <SmartIcon
              name={"download"}
              fill="#fff"
              className="w-5 h-5 cursor-pointer"
            />
          </div>
        )
        }
      </td>
    </tr>
  )
}

export default TranscriptionFeatureProgress;